import React, { useState } from "react";
import ViewWeekOutlinedIcon from "@mui/icons-material/ViewWeekOutlined";
import { Button, Checkbox, FormControlLabel, Popover, Stack, Typography } from "@mui/material";

/** The three columns a reader can turn off. Every other column is always shown. */
export type QuotesListColumnVisibility = {
  fulfilment: boolean;
  term: boolean;
  lastUpdated: boolean;
};

export const allColumnsVisible: QuotesListColumnVisibility = { fulfilment: true, term: true, lastUpdated: true };

const columnToggles: { key: keyof QuotesListColumnVisibility; label: string }[] = [
  { key: "fulfilment", label: "Fulfilment" },
  { key: "term", label: "Term" },
  { key: "lastUpdated", label: "Last updated" },
];

/**
 * The Display button and the column popover behind it. The three labels are the design's, and each
 * one names a column group rather than a column: `Term` covers the Term End column.
 * @param root0
 * @param root0.visibility
 * @param root0.onVisibilityChange
 */
export function DisplayPopover({
  visibility,
  onVisibilityChange,
}: {
  visibility: QuotesListColumnVisibility;
  onVisibilityChange: (key: keyof QuotesListColumnVisibility, isVisible: boolean) => void;
}) {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  return (
    <>
      <Button
        variant="outlined"
        color="secondary"
        startIcon={<ViewWeekOutlinedIcon />}
        onClick={(event) => setAnchorEl(event.currentTarget)}
      >
        Display
      </Button>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        <Stack sx={{ p: 2, width: 220 }}>
          <Typography variant="overline" color="text.secondary">
            Columns
          </Typography>
          {columnToggles.map((toggle) => (
            <FormControlLabel
              key={toggle.key}
              label={toggle.label}
              control={
                <Checkbox
                  checked={visibility[toggle.key]}
                  onChange={(event) => onVisibilityChange(toggle.key, event.target.checked)}
                />
              }
            />
          ))}
        </Stack>
      </Popover>
    </>
  );
}
